import { Children } from 'react';
function mergeRefs(ref1, ref2) {
    return function (element) {
        assignRef(ref1, element);
        assignRef(ref2, element);
    };
}
function assignRef(ref, element) {
    if (typeof ref === 'function') {
        ref(element);
    }
    else if (ref) {
        // @ts-ignore
        ref.current = element;
    }
}
function getText(children) {
    if (!Boolean(children) && typeof children !== 'number') {
        return '';
    }
    if (typeof children === 'object' && children.props) {
        return Children.map(children.props.children, function (child) {
            return getText(child);
        }).join('');
    }
    return String(children);
}
function isExternalLink(url) {
    return !!url && /^https?:\/\//.test(url);
}
function callAll() {
    var fns = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        fns[_i] = arguments[_i];
    }
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return fns.forEach(function (fn) { return fn && fn.apply(void 0, args); });
    };
}
function getErrorMessage(id, errors) {
    return (errors.find(function (_a) {
        var errorId = _a.id;
        return id === errorId;
    }) || { message: null })
        .message;
}
function remToNumber(rem) {
    return parseFloat(rem);
}
function pxToNumber(px) {
    return parseFloat(px);
}
function remToPx(rem) {
    return remToNumber(rem) * 10 + 'px';
}
function filterChildrenByType(children, type) {
    return Children.toArray(children).filter(function (child) { return (child === null || child === void 0 ? void 0 : child.type) === type; });
}
export { mergeRefs, getText, isExternalLink, callAll, getErrorMessage, remToNumber, pxToNumber, remToPx, filterChildrenByType, };
